import {drawPolyline,drawDot} from "@/components/cyphers/helpers/drawSvg";

const Width = 100;
const Height = Width;
const Padding = 5;
function CharPaths(width,height,padding) {
    return [[width+padding,padding,  width+padding,height+padding,  padding,height+padding],
        [padding,padding,  padding,height+padding,  width+padding,height+padding,  width+padding,padding],
        [padding,padding,  padding,height+padding,  width+padding,height+padding,],
        [padding,padding,  width+padding,padding,  width+padding,height+padding, padding,height+padding],
        [padding,padding,  width+padding,padding,  width+padding,height+padding, padding,height+padding,  padding,padding],
        [width+padding,padding, padding,padding,  padding,height+padding,  width+padding,height+padding, padding,height+padding],
        [padding,padding, width+padding,padding, width+padding,height+padding],
        [padding,height+padding,  padding,padding,  width+padding,padding,  width+padding,height+padding],
        [padding,height+padding,  padding,padding,  width+padding,padding,]
];
}
// 0-8, 9-17, 18-26
export function drawChar(canvas, charNumber, width=Width,height=Height,padding=Padding){
    drawPolyline(canvas, CharPaths(width, height, padding)[(charNumber%9)], 3)
    drawDot(canvas, padding+(height/2),padding+(width/2),padding, (charNumber/9>>0) )
}
